import * as React from 'react'

import { Slot } from '@radix-ui/react-slot'
import { type VariantProps } from 'class-variance-authority'
import { Loader2 } from 'lucide-react'

import { cn } from '@/lib/utils'

import { buttonLoadingVariants, buttonVariants } from './button.style'

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
  isLoading?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { asChild = false, children, className, disabled, fullwidth, isLoading, size, type = 'button', variant, ...props },
    ref,
  ) => {
    const Comp = asChild ? Slot : 'button'
    return (
      <Comp
        className={cn(buttonVariants({ className, fullwidth, size, variant }))}
        disabled={isLoading || disabled}
        ref={ref}
        type={type}
        {...props}
      >
        {children}
        {isLoading && (
          <span className={cn(buttonLoadingVariants({ variant }))}>
            <Loader2 className="animate-spin" size={16} />
          </span>
        )}
      </Comp>
    )
  },
)
Button.displayName = 'Button'

export { Button }
